const withTrailingSlash = (value: string): string =>
  value.endsWith('/') ? value : `${value}/`;

const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || '/api/';
const appEndpoint = import.meta.env.VITE_APP_ENDPOINT || window.location.origin;

export const env = Object.freeze({
  apiEndpoint: withTrailingSlash(apiEndpoint),
  appEndpoint: withTrailingSlash(appEndpoint),
  minimumUsdt: Number(import.meta.env.VITE_MIN_USDT || 100),
  bestChangeId: import.meta.env.VITE_BESTCHANGE_ID || '',
  skyCapitalRegisterUrl:
    import.meta.env.VITE_SKY_CAPITAL_REGISTER_URL ||
    'https://skycapital.group/external-auth',
  yandexMetrikaCounterId: Number(import.meta.env.VITE_YANDEX_METRIKA_COUNTER_ID || 95365919),
});
